module.exports = __webpack_public_path__ + "img/a55932c.jpg";